import logo from '../../layout/leftnav/ppm-logo.png';
import errorSvg from '../../images/error.svg';

//css is defined and loaded in /layout/boundary/ErrorBoundary.css
const GlobalError = props => {
    return (
        <div className="d-flex" id="wrapper">
            <div className="border-end" id="sidebar-wrapper">
                <div>
                    <div className="sidebar-heading"><img src={logo} alt="Payment Portal Logo" /></div>
                    <nav className="nav">{/* empty nav container needed for rendering below 990px widths */}</nav>
                </div>
            </div>
            <div id="page-content-wrapper">
                <div id="error-content" data-testid="error-content">
                    <div className="bubble"><img src={errorSvg} alt="error" /></div>

                    <p>Sorry, an unexpected error occurred and the page is temporarily unavailable.
                    If the error persists, please contact your Commerce Support Team.</p>
                    <a href="/company/default/dashboard">Go to Dashboard</a>
                </div>
            </div>
        </div>
    );
};

export default GlobalError;